import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import AddDomain from "@/pages/AddDomain";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import MarketingDashboard from "@/pages/MarketingDashboard";
import BlogArticle from "@/pages/BlogArticle";
import BlogIndex from "@/pages/BlogIndex";
import Validations from "@/pages/Validations";
import ValidationList from "@/pages/ValidationList";
import WorkspaceUpgrade from "@/pages/WorkspaceUpgrade";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard/add-domain" element={<ProtectedRoute><AddDomain /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/admin/marketing" element={<ProtectedRoute adminOnly><MarketingDashboard /></ProtectedRoute>} />
            <Route path="/validations" element={<ProtectedRoute><Validations /></ProtectedRoute>} />
            <Route path="/validations/:listId" element={<ProtectedRoute><ValidationList /></ProtectedRoute>} />
            <Route path="/workspace-upgrade" element={<WorkspaceUpgrade />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
